// extracted by mini-css-extract-plugin
export default {"wrapper":"Nothing_wrapper__BzlHW","btn":"Nothing_btn__KDOCX"};